export const CHANGE_NOTIFICATION_COUNT = "CHANGE_NOTIFICATION_COUNT"
export const CHANGE_NOTIFICATION_LIST = "CHANGE_NOTIFICATION_LIST"
export const CHANGE_NOTIFICATION_MENU = "CHANGE_NOTIFICATION_MENU"